import Repository from './Repository';

const resource = '/users';
export default {
  get(config) {
    return Repository.get(`${resource}`, config);
  },
  getLeaderboard(config) {
    return Repository.get(`${resource}/leaderboard`, config);
  },
  getLeaderboardAll(config) {
    return Repository.get(`${resource}/leaderboard/all`, config);
  },
}